
/**
 *      @fileOverview
 *      FOD Wiki search UI
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 05/04/2018
 *      Modified on 03/04/2019
 */

/**
 * Query Data Model Registry for the FOD Wiki data model
 */
function displayFODWikiSearchResults() {
    var model,
        url,
        searchAlias,
        type = 'fodwiki', // FOD Wiki type (index)
        alias = 'fod'; // FOD Wiki alias


    searchAlias = App.globalState.alias;


    if ( searchAlias === "eva" ) {
        if (type && alias) {
            // check if CDM model exists already
            model = getDataModel(type, false);
            if (!model) {
                url = "/dmr/api/v1/" + type + "/ui";
                makingAjaxRequest = true;
                makeAjaxRequest(url, FODDataModelFound(type, alias), dataNotFound( url ));
            } else {
                // get FOD Wiki results
                getFODWikiSearchResults(model, type, alias);
            }
        }
    }
}

/**
 * Save FOD Wiki data model and proceed to query the Search API
 * @param type {string} - FOD data type
 * @param alias {string} - FOD data alias
 * @returns {Function}
 */
function FODDataModelFound( type, alias ) {
    /**
     * Callback that is called when the call to fetch the FOD Wiki data model succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {
        makingAjaxRequest = false;
        if ( data ) {
            // save FOD Wiki data model to the global models variable
            saveDataModel( type, data );
            // get FOD Wiki results
            getFODWikiSearchResults( data, type, alias );
        }
    };
}

/**
 * Query Search API for FOD Wiki records
 * @param model {object} - FOD Wiki data model
 * @param type {string} - FOD data type
 * @param alias {string} - FOD data alias
 */
function getFODWikiSearchResults( model, type, alias ) {
    var url,
        query;
    if ( type && alias ) {
        if ( App && App.globalState && App.globalState.query ) {
            query = App.globalState.query;
        }
        if ( query ) {
            url = App.globalState.searchAPIBase + "?q=" + query + "&type=" + type + "&alias=" + alias + "&page=1&pagesize=100";
            makingAjaxRequest = true;
            makeAjaxRequest( url, FODRecordsFound( model ), dataNotFound( url ) );
        }
    }
}

/**
 * Display FOD Wiki search results
 * @param model {object} - FOD Wiki data model
 * @return {Function}
 */
function FODRecordsFound( model ) {
    /**
     * Callback that is called when the call to fetch the FOD Wiki data model succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {

        makingAjaxRequest = false;
        if ( data ) {
            // display FOD results
            displayFODWikiSearch( data, model );
        }
    };
}

/**
 * Display FOD Wiki search results based on FOD Wiki DMR model
 * @param data {object} - Search results
 * @param model {object} - FOD Wiki data model
 */
function displayFODWikiSearch( data, model ) {

    if ( data && data.hits ) {
        var records = data.hits.hits;
        if (records) {

            var linksCollection = new BackboneCollection();

            // Find image links
            for (var i = 0; i < records.length; i++) {
                var record = records[i];
                if ( record ) {
                    linksCollection = createLinksCollection( record._source, linksCollection );
                }
            }

            // create FOD Wiki summary
            if ( linksCollection.models && linksCollection.models.length > 0 ) {

                // append images to the FOD Wiki view
                var FODView = new FODItemsView( { collection: linksCollection });
                if ( App.globalState.layout && App.globalState.layout.getRegion('fodWikiRegion') && $(App.globalState.layout.getRegion('fodWikiRegion').el).length > 0 ) {
                    App.globalState.layout.getRegion( 'fodWikiRegion' ).show( FODView );

                    // Abbreviate the description element
                    // $( '.image-description' ).dotdotdot({
                    //     height: 90
                    // });
                }
            }
        }
    }
}

/**
 * Populate links collection with data from one record
 * @param source {object} - data record source
 * @param linksCollection {object} - links Backbone.Collection
 * @return {object}
 */
function createLinksCollection( source, linksCollection ) {

    var images,
        externallinks,
        linkModel,
        j;
    if ( source && linksCollection) {

        // Look at the source.text.alltext
        var text = source.text;
        if ( text ) {
            var alltext = text.alltext;


            var regex = /\/img_auth.php\/thumb\S+\.(png|svg|jpg|jpeg|apng|bmp|gif)/g;

            var found = alltext.match( regex );

            images = source.images;

            var foundUrls = {};
            // Check the found images array to search for images in the source.images
            if ( found && images ) {
                for ( var i = 0; i < found.length; i++ ) {
                    var foundUrl = found[i];
                    for ( var j = 0; j < images.length; j++ ) {
                        var image = images[j];
                        if ( foundUrl.indexOf(image) > -1 ) {

                            // Check if URL already exists in the found URLs array
                            if ( ! foundUrls.hasOwnProperty( image ) ) {
                                foundUrls[ image ] = foundUrl;
                            }
                        }
                    }
                }
            }

            // Add image URLs that were found in both the images field and the all text of the search result
            for ( var key in foundUrls ) {
                if ( foundUrls.hasOwnProperty( key ) ) {
                    linkModel = getImageLinkModel( key, foundUrls[ key ] );
                    if ( linkModel ) {
                        linkModel = setLinkModelFields( linkModel, source );

                        // *******
                        // Commenting out because of cross-browser compatibility and possible attacks
                        //linksCollection.add( linkModel );
                    }
                }
            }
        }

        // Look at the source.externallinks field to get the external Wiki images
        externallinks = source.externallinks;


        if ( externallinks ) {
            for ( j = 0; j < externallinks.length; j++) {
                linkModel = getExternalLinkModel( externallinks[j] );
                if ( linkModel ) {

                    linkModel = setLinkModelFields( linkModel, source );
                    linksCollection.add( linkModel );
                }
            }
        }
    }


   return linksCollection
}

/**
 * Set link model field values
 * @param linkModel {object} - link Backbone model
 * @param source {object} - link source object
 * @return {*}
 */
function setLinkModelFields( linkModel, source ) {
    var description;
    if ( linkModel && source ) {
        linkModel.set( "pageid", source.pageid );
        linkModel.set( "revid", source.revid );
        linkModel.set( "displayTitle", source.displaytitle );

        // If image title is not defined, set it to record title
        if ( ! linkModel.get("title") ) {
            linkModel.set("title", source.displaytitle);
        }


        description = source.edi_description;
        if ( ! description && source.text ) {
            description = source.text.alltext;
        }
        linkModel.set( "edi_description", description );

    }
    return linkModel;
}

/**
 * Create a new model and set the src attribute
 * @param title {string} - image title
 * @param link {string} - image relative URL
 * @return {*}
 */
function getImageLinkModel( title, link ) {

    var linkModel;
    if ( link ) {
        // Set link to lower case
        link = link.toLowerCase();
        // Ignore links that do not have valid image extensions
        if ( link.endsWith('.jpg') || link.endsWith('.jpeg') || link.endsWith('.gif') || link.endsWith('.png') || link.endsWith('.apng') || link.endsWith('.svg') || link.endsWith('.bmp') ) {
            linkModel = new BackboneModel();
            linkModel.set( "src", "https://wiki.jsc.nasa.gov/iss" + link );
            linkModel.set( "title", title );
        }
    }
    return linkModel;
}

/**
 * Create a new model and set the src attribute
 * @param externallink {string} - external link URL
 * @return {*}
 */
function getExternalLinkModel( externallink ) {

    var linkModel;
    if ( externallink ) {
        var link = externallink.toLowerCase();
        // Ignore links that do not have valid image extensions
        if (link.endsWith('.jpg') || link.endsWith('.jpeg') || link.endsWith('.gif') || link.endsWith('.png') || link.endsWith('.apng') || link.endsWith('.svg') || link.endsWith('.bmp')) {
            linkModel = new BackboneModel();
            linkModel.set( "src", externallink );
        }
    }
    return linkModel;
}

/**
 * Convert input string into the FOD Wiki link format
 * Encode the title into the URI format and replace spaces with underscores
 * @param link {string} - link string to convert
 * @retrun {string}
 */
function convertToFODLinkFormat( link ) {
    var result,
        reg,
        reg2,
        reg3;

    if ( link ) {
        result = encodeURIComponent( link );

        // Replace space characters with underscores
        reg = new RegExp(' ', 'g');
        result = result.replace(reg, '_');

        reg2 = new RegExp('%20', 'g');
        result = result.replace(reg2, '_');

        reg3 = new RegExp('/+/', 'g');
        result = result.replace(reg3, '_');
    }
    return result;
}

/**
 * FOD Wiki items view
 */
var FODItemsView = Marionette.ItemView.extend({
    template: '#fod-items-template'
});